import { render, staticRenderFns } from "./ProjectInformation.vue?vue&type=template&id=b2f67a28&scoped=true"
import script from "./ProjectInformation.vue?vue&type=script&lang=js"
export * from "./ProjectInformation.vue?vue&type=script&lang=js"
import style0 from "./ProjectInformation.vue?vue&type=style&index=0&id=b2f67a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f67a28",
  null
  
)

export default component.exports